<template>

  <div id="tavolos" v-if="restaurant_status === true">

    <Book
      v-if="publisher_id === 0"
      :restaurant_id="tavolos_restaurant_id"
      :publisher_id="publisher_id">
    </Book>

    <BKAsiaCity
      v-if="publisher_id === publisher_id_bkasiacity"
      :restaurant_id="tavolos_restaurant_id"
      :publisher_id="publisher_id">
    </BKAsiaCity>

    <TopTables
      v-if="publisher_id === publisher_id_toptables"
      :restaurant_id="tavolos_restaurant_id"
      :publisher_id="publisher_id">
    </TopTables>

    <HotelIntel
      v-if="publisher_id === publisher_id_hotelintel"
      :restaurant_id="tavolos_restaurant_id"
      :publisher_id="publisher_id">
    </HotelIntel>

  </div>

</template>

<script>

  import Book from './Book.vue'
  import BKAsiaCity from './BKAsiaCity.vue'
  import TopTables from './TopTables.vue'
  import HotelIntel from './HotelIntel.vue'

  import axios from 'axios'
  const apiURL = 'https://admin.tavolos.com/api'
  // const apiURL = 'https://stage-admin.tavolos.com/api'

  export default {
    components: {
      Book, BKAsiaCity, TopTables, HotelIntel
    },

    data () {
      return {

        // Publisher_id
        publisher_id_bkasiacity: 1,
        publisher_id_toptables: 232,
        publisher_id_hotelintel: 317,

        // Default model variable
        restaurant_status: false,
        tavolos_restaurant_id: '',
      }
    },
    props: {
      // Set default value on property
      publisher_id: {
        default: 0,
      },
      restaurant_id: {
        required: true,
        default: 0,
      }
    },
    methods: {
      randomParameter: function () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 1; i < 8; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      },

      isEmpty (value) {
        return (value == null || value.length === 0)
      }
    },

    created: function () {

      const self = this

      // if no publisher_id
      if (this.publisher_id === undefined || this.publisher_id === 0) {
        self.tavolos_restaurant_id = self.restaurant_id

        // fetch data
        axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
          .then(function (response) {
            // Check value available by restaurant name
            var checkRestaurantHasName = response.data.restaurants[0].restaurant
            if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
              self.restaurant_status = true
            }

          })
          .catch(function (error) {
            console.log(error)
          })
      }

      // If have publisher_id, ask tavolos nid
      if (this.publisher_id !== undefined || this.publisher_id !== 0) {

        axios.get(apiURL + '/publishers/' + self.publisher_id + '/restaurants/' + self.restaurant_id + '?_format=json' + '&' + self.randomParameter())
          .then(function (response1) {

            // If publisher_id do not exist
            if (response1.data.result === 'error') {

              self.tavolos_restaurant_id = self.restaurant_id

              // fetch data
              axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
                .then(function (response2) {

                  // Check value available by restaurant name
                  var checkRestaurantHasName = response2.data.restaurants[0].restaurant
                  if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
                    self.restaurant_status = true
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })
            }

            if (response1.data.result === 'success') {

              // fetch data
              self.tavolos_restaurant_id = response1.data.tavolos_restaurant_id

              axios.get(apiURL + '/restaurants/' + response1.data.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
                .then(function (response2) {

                  // Check value available by restaurant name
                  var checkRestaurantHasName = response2.data.restaurants[0].restaurant
                  if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
                    self.restaurant_status = true
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    mounted () {

    }
  }
</script>


<style lang="scss" scoped>
  #tavolos {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/TavolosWidget.vue